import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationService } from '../registration.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-account-creation-modal',
  templateUrl: './account-creation-modal.component.html',
  styleUrls: ['./account-creation-modal.component.scss']
})
export class AccountCreationModalComponent implements AfterViewInit {
  @Input() isSuccess: boolean;
  @Input() formData: any;
  @Input() idType: string;
  @ViewChild('modalTitle') modalTitle: ElementRef;

  forgetEmailDisabled:boolean = false;
  
  get name(): string {
    if (!this.formData) return '';
    const firstName = this.formData.firstName || '';
    const lastName = this.formData.lastName || '';
    
    let fullName = firstName + ' ' + lastName;
    return fullName;
  }
  
  get email(): string {
    const email = this.formData?.email || '';
    if (!email || email.length < 8) return email;
    
    const [localPart, domain] = email.split('@');
    if (!localPart || !domain) return email;
    
    // Show first 2 characters of local part, mask the rest
    const maskedLocal = localPart.substring(0, 2) + '****';
    
    // Show first 2 characters of domain, mask the rest before the TLD
    const domainParts = domain.split('.');
    if (domainParts.length < 2) return email;
    
    const maskedDomain = domainParts[0].substring(0, 2) + '***';
    const tld = domainParts.slice(1).join('.');
    
    return `${maskedLocal}@${maskedDomain}.${tld}`;
  }
  
  get phone(): string {
    const phone = this.formData?.phoneNumber || '';
    if (!phone || phone.length < 10) return phone;
    
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');
    
    // Show first and last digits of each segment (format: 9**-3**-6412)
    if (digits.length === 10) {
      return `${digits[0]}**-${digits[3]}**-${digits.slice(-4)}`;
    } else if (digits.length === 11) {
      // For 11-digit numbers (e.g., with country code)
      return `${digits[0]}-${digits[1]}**-${digits[4]}**-${digits.slice(-4)}`;
    }
    
    return phone;
  }
  
  get idValue(): string {
    const idValue = this.formData?.ssn || this.formData?.itin || '';
    if (!idValue || idValue.length < 4) return idValue;
    return '***-**-' + idValue.slice(-4);
  }
  constructor(public activeModal: NgbActiveModal, private readonly registrationService: RegistrationService, private router: Router) {}
  
  ngAfterViewInit() {
    // Set focus to the modal title for screen reader announcement
    setTimeout(() => {
      if (this.modalTitle && this.modalTitle.nativeElement) {
        this.modalTitle.nativeElement.focus();
      }
    }, 100);
  }
  
  modalClose() {
    this.activeModal.close();
  }
  forgotEmail() {
    this.forgetEmailDisabled = true;
    this.activeModal.close();
    this.router.navigate(['/app-login/forgot-email']);
  }
}
